import { Amplify, ResourcesConfig } from 'aws-amplify';

export const config: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.COGNITO_USERPOOLID ?? '',
      userPoolClientId: process.env.COGNITO_CLIENTID ?? '',
      loginWith: {
        email: true,
      },
      userAttributes: {
        given_name: {
          required: true,
        },
        family_name: {
          required: true,
        },
      },
    },
  },
};

export function configure(resources?: ResourcesConfig) {
  Amplify.configure(resources ?? config, {
    ssr: true, // required when using Amplify with Next.js
  });
}
